import { useViewMode } from 'store/app/appStore';
import {
  type ResourceType,
  type CampaignTypes,
  useCampaignCollapsibleState,
  useCampaignBackgroundImage,
} from 'features/campaigns';
import { useHasMany } from '../../store/campaignsStore';

export const useCampaignCardState = (resources: ResourceType, campaignType?: CampaignTypes) => {
  const viewMode = useViewMode();
  const hasMany = useHasMany(campaignType);

  const { isCollapsed, arrow, handleArrowClick } = useCampaignCollapsibleState();
  const { backgroundImageUrl } = useCampaignBackgroundImage(resources, campaignType);

  return {
    viewMode,
    isCollapsed,
    hasMany,
    backgroundImageUrl,
    arrow,
    handleArrowClick,
  };
};
